import toastr from "toastr";
import { RestMethod } from "../ApiConfig/RestMethod";
// import RestMethod from "../ApiConfig/RestMethod";

export const CallApi = async (api, Method, data) => {
  try {
    const response = await RestMethod[Method](api, data);

    // if (!response?.data?.status)
    //   toastr.info(response?.data?.message || "Something Went Wrong");

    return response?.data;
  } catch (error) {
    toastr.error(error);
    return {
      status: 0,
      message: error,
    };
  }
};
